import * as TYPES from 'data/nodeTypes';

import {
  getAnswerValueColumnTypesOpenEnded,
  getDefaultColumnsAndAnswers,
} from 'containers/QuestionnairePage/GenericQuestion/MatrixOpenEndedQuestion/utils';

function getDefaultNodeValuesForMatrix(question) {
  const {
    refId: questionRefId,
    matrix = {},
    answers: defaultAnswers,
  } = question;
  const {
    matrixAnswers: defaultMatrixAnswers = [],
    columns: defaultColumns = [],
    answerColumnValueTypes = [],
  } = matrix;

  const matrixAnswers = [...(defaultMatrixAnswers || [])];
  const columns = [...(defaultColumns || [])];
  const answers = [...defaultAnswers];

  const { newAnswers, newMatrixAnswers, newColumns } =
    getDefaultColumnsAndAnswers({
      answers,
      matrixAnswers,
      columns,
      questionRefId,
      questionType: question.type,
    });

  const newAnswerColumnValueTypes = getAnswerValueColumnTypesOpenEnded({
    answers: newAnswers,
    columns: newColumns,
    answerColumnValueTypes,
    questionType: question.type,
  });

  return {
    ...question,
    answers: newAnswers,
    matrix: {
      ...matrix,
      matrixAnswers: newMatrixAnswers,
      columns: newColumns,
      answerColumnValueTypes: newAnswerColumnValueTypes,
    },
  };
}

export const NEW_QUESTION_DEFAULT_VALUES = {
  [TYPES.QUESTION_MATRIX_OPEN_ENDED]: getDefaultNodeValuesForMatrix,
  [TYPES.QUESTION_MATRIX_CONSTANT_SUM]: getDefaultNodeValuesForMatrix,
  [TYPES.QUESTION_CONVERSATIONAL]: getDefaultNodeValuesForMatrix,
};
